import { dashboardService } from '../services';
import { dashboardConstants } from '../constants';

export const dashboardActions = {
  getTopFiveAreas
}

function getTopFiveAreas(data) {
  return (dispatch) => {
    dispatch({ 
      type: dashboardConstants.GET_DASHBOARD_CSV_REQUEST 
    });
    dashboardService.getDashboardReportsCsv(data) 
      .then(response => {
        dispatch({ 
          type: dashboardConstants.GET_DASHBOARD_CSV_SUCCESS,
          payload: response.data.data.csv
        });
      })
      .catch((err) => {
        dispatch({ 
          type: dashboardConstants.GET_DASHBOARD_CSV_FAILURE,
         })
      })
  }
}